import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import api from '../lib/api';

const BookSettingsModal = ({ open, onClose, book, onSave }) => {
  const [customPages, setCustomPages] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (book) setCustomPages(book.effective_total_pages || book.total_pages || '');
  }, [book]);

  const handleSave = async () => {
    const pages = parseInt(customPages);
    if (!pages || pages <= 0) {
      toast.error('يرجى إدخال عدد صفحات صحيح');
      return;
    }

    setLoading(true);
    try {
      await api.post('/user/book-settings', {
        book_key: book.book_key,
        course_id: book.course_id,
        custom_pages: pages,
      });
      toast.success('تم حفظ الإعدادات بنجاح');
      onSave && onSave(pages);
      onClose();
    } catch (error) {
      toast.error('فشل حفظ الإعدادات');
    } finally {
      setLoading(false);
    }
  };

  if (!book) return null;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px] bg-white" data-testid="book-settings-modal">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-accent">
            إعدادات الكتاب
          </DialogTitle>
          <p className="text-muted-foreground mt-2">{book.title}</p>
        </DialogHeader>

        <div className="space-y-6 mt-4">
          <div className="bg-muted/30 p-4 rounded-lg">
            <p className="text-sm text-muted-foreground mb-1">العدد الأصلي للصفحات</p>
            <p className="text-2xl font-bold text-accent">{book.total_pages} صفحة</p>
          </div>

          <div>
            <Label htmlFor="custom-pages" className="text-lg font-semibold">
              عدد الصفحات في طبعتك
            </Label>
            <Input
              id="custom-pages"
              type="number"
              min="1"
              value={customPages}
              onChange={(e) => setCustomPages(e.target.value)}
              placeholder="أدخل عدد الصفحات"
              className="mt-2 h-12 text-lg text-center no-spinners"
              data-testid="custom-pages-input"
            />
            <p className="text-sm text-muted-foreground mt-2">
              إذا كانت طبعة كتابك تختلف في عدد الصفحات، يمكنك تغييره هنا
            </p>
          </div>

          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="flex-1"
              disabled={loading}
              data-testid="cancel-settings-btn"
            >
              إلغاء
            </Button>
            <Button
              onClick={handleSave}
              className="flex-1 bg-primary hover:bg-primary/90"
              disabled={loading}
              data-testid="save-settings-btn"
            >
              {loading ? 'جارٍ الحفظ...' : 'حفظ الإعدادات'}
            </Button>
          </div>
        </div>

        <style>{`
          .no-spinners::-webkit-outer-spin-button,
          .no-spinners::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
          .no-spinners { -moz-appearance: textfield; }
        `}</style>
      </DialogContent>
    </Dialog>
  );
};

export default BookSettingsModal;
